import moment from 'moment';

const filterAvailableDate = (availabilities, date) => {
  return Array.from(availabilities).filter(a => moment(a.time.start).format('DD MM YYYY') === date.format('DD MM YYYY'));
};

export default filterAvailableDate;